import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { eHierarchyLevel } from "../../../functions/api/enums";
import { ActiveNavLink } from "../ActiveNavLink";

/**
 * Table cell renderer that displays a navigation link to the TLF designer.
 *
 * @param props - The component props
 * @param props.rowData - Row data containing TLF item ID and version information
 */
export const TlfItemTableLinkCell = ({
  rowData,
}: ISimpleTableCellRenderProps): React.ReactElement => {
  const searchParams = rowData.searchParams as URLSearchParams | undefined;

  return (
    <ActiveNavLink
      id={`tlfitemtable-link-${rowData.id}`}
      to={
        rowData.primaryHierarchyLevel === eHierarchyLevel.Report
          ? `/TlfDesigner/${rowData.id}${searchParams ? `?${searchParams.toString()}` : ""}`
          : `/TlfDesigner/${rowData.azsolId}/${rowData.version}${searchParams ? `?${searchParams.toString()}` : ""}`
      }
    >
      {rowData.primaryHierarchyLevel === eHierarchyLevel.Report
        ? `${rowData.tocNumber ?? "!!toc!! not set"}`
        : `${rowData.azsolId}/${rowData.version}`}
    </ActiveNavLink>
  );
};

TlfItemTableLinkCell.displayName = "TlfItemTableLinkCell";
